import React from 'react';
import { motion } from 'framer-motion';

const TextArea = ({ value, onChange, placeholder, className = '', readOnly = false }) => {
  return (
    <motion.textarea
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      readOnly={readOnly}
      className={`w-full p-4 bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 ${className} ${
        readOnly ? 'cursor-default' : ''
      }`}
      maxLength={20000}
    />
  );
};

export default TextArea;